import { Div, TableCell, TableRow } from "@tblabs/truffle";
import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";
import { Markdown } from "../../Utils/Markdown";
import { TableField } from "./TableField";


export class TablePrinter extends Div
{
    constructor(field: TableField)
    {
        super("product__specs");

        const table = new Table().Class("product__specs-table")
        
        const tableRows = field.Rows.Items;

        for (const row of tableRows)
        {
            table.Append(
                new TableRow().Class("product__specs-row").Append(
                    new TableCell(new Markdown(row.Left.value)).Class("product__specs-cell product__specs-label"),
                    new TableCell(new Markdown(row.Right.value)).Class("product__specs-cell product__specs-value")
                )
            )
        }

        this.Append(table)
    }
}
